var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Hot-Pursuit privacy policy")]),_c('h2',[_vm._v("Information collected")]),_c('p',[_vm._v("No informations are collected")]),_c('h2',[_vm._v("Contact")]),_c('p',[_vm._v("Contact us by email at club.babypro@gmail.com")])])
}]

export { render, staticRenderFns }